/* eslint-disable complexity */

/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";

export const SEO: React.FC<DogsTrust.SEOMetaProps> = ({
	title,
	description,
	abstract,
	keywords,
	canonical_url,
	robots,
	og_type,
	og_url,
	og_title,
	og_description,
	og_image_url,
	twitter_cards_type,
	twitter_cards_description,
	twitter_cards_site,
	twitter_cards_title,
	twitter_cards_image,
	schemaMarkup,
}) => {
	return (
		<>
			<title>{title}</title>
			<meta name={"title"} content={title} />
			<link rel="canonical" href={canonical_url || ""} />
			<meta name={"description"} content={description} />
			<meta name={"abstract"} content={abstract || ""} />
			<meta name={"keywords"} content={keywords || ""} />
			<meta name={"robots"} content={robots || ""} />
			<meta property={"og:image"} content={og_image_url || ""} />
			<meta property={"og:title"} content={og_title} />
			<meta property={"og:description"} content={og_description} />
			<meta property={"og:url"} content={og_url} />
			<meta property={"og:type"} content={og_type} />
			<meta name={"twitter:card"} content={twitter_cards_type} />
			<meta name={"twitter:site"} content={twitter_cards_site} />
			<meta name={"twitter:image"} content={twitter_cards_image || ""} />
			<meta name={"twitter:creator"} content={"Dog's Trust"} />
			<meta name={"twitter:title"} content={twitter_cards_title} />
			<meta name={"twitter:description"} content={twitter_cards_description} />
			<meta property={"fb:app_id"} content={"279663086961898"} />

			{schemaMarkup && (
				<script type="application/ld+json">
					{JSON.stringify(schemaMarkup)}
				</script>
			)}
		</>
	);
};

export default SEO;
